<template>
  <CFooter :fixed="false">
    <div class="d-none d-sm-block">
      <img src="/img/igrain/footer/about.jpg" style="width: 20%; object-fit: cover;"/>
      <img src="/img/igrain/footer/crop.jpg" style="width: 20%; object-fit: cover;"/>
      <img src="/img/igrain/footer/cropping.jpg" style="width: 20%; object-fit: cover;"/>
      <img src="/img/igrain/footer/grain.jpg" style="width: 20%; object-fit: cover;"/>
      <img src="/img/igrain/footer/finance.jpg" style="width: 20%; object-fit: cover;"/>
    </div>
    <div class="d-block d-sm-none">
      <img src="/img/igrain/footer/about.jpg" style="width: 33.3%; object-fit: cover;"/>
      <img src="/img/igrain/footer/crop.jpg" style="width: 33.3%; object-fit: cover;"/>
      <img src="/img/igrain/footer/cropping.jpg" style="width: 33.3%; object-fit: cover;"/>
    </div>
    <div class="footer-container">
      <CRow  class="m-2">
        <CCol col=12 sm=12 md=5 lg=5 class="text-center mb-4">
          <img src="/img/igrain/footer/logo.png" class="mb-2" style="width: 200px;"/>
          <div>© igrain Pty Ltd. All Rights Reserved</div>
        </CCol>
        <CCol col=12 sm=4 md=2 lg=2 class="mb-3">
          <CRow>
            <CCol col=6 sm=12>
              <CLink to="/" class="text-white">Home</CLink><br/>
              <!-- <CLink to="/about" class="text-white">About us</CLink><br/> -->
            </CCol>
            <CCol>
              <CLink to="/privacy" class="text-white">Privacy policy</CLink><br/>
              <a class="text-white" href="/img/igrain/terms/terms-and-conditions.pdf" target="blank">Terms & conditions</a><br/>
            </CCol>
          </CRow>
        </CCol>
        <CCol col=6 sm=4 md=3 lg=2>
          <h5>Contact</h5>
          <FooterContact />
        </CCol>
        <CCol col=6 sm=4 md=2 lg=3>
          <h5>Follow</h5>
          <FooterFollow />
        </CCol>
      </CRow>
    </div>
  </CFooter>
</template>

<script>
import FooterFollow from './FooterFollow'
import FooterContact from './FooterContact'

export default {
  name: 'Footer',
  components: {
    FooterFollow,
    FooterContact
  }
}
</script>

<style scoped>
footer {
  padding-left: 0;
  padding-right: 0;
}
.footer-container {
  padding: 15px;
  background-color: #163745;
  color: white;
  width: 100%;
}
</style>
